// extracted by mini-css-extract-plugin
export var chevronIcon = "_c4-2";
export var teamName = "_c4-1";
export var teamSwitcherButton = "_c4-0";